import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const StandardInput: React.FunctionComponent<{
    id?: string;
    name?: string;
    value?: any;
    onChange?: (e: any) => void;
    onKeyDown?: (e: any) => void;
    onKeyUp?: (e: any) => void;
    onBlur?: (e: any) => void;
    onClick?: (e: any) => void;
    onIconClick?: (e: any) => void;
    placeholder?: string;
    type?: string;
    hasError?: boolean;
    errorMessage?: string;
    className?: string;
    label?: string;
    required?: boolean;
    autoFocus?: boolean;
    minLength?: number;
    maxLength?: number;
    min?: number;
    max?: number;
    step?: string;
    minRows?: number;
    maxRows?: number;
    fullWidth?: boolean;
    selectOptions?: any;
    disabled?: boolean;
    standard?: boolean;
    readOnly?: boolean;
    icon?: IconProp;
    aria?: string;
    adjustWidth?: boolean;
    style?: any;
    overrideIconStyle?: boolean;
    marginBottom?: boolean;
}> = ({
    id,
    name,
    value,
    onChange = () => {
        return;
    },
    onKeyDown = () => {
        return;
    },
    onKeyUp = () => {
        return;
    },
    onBlur = () => {
        return;
    },
    onClick = () => {
        return;
    },
    onIconClick = () => {
        return;
    },
    placeholder,
    type = 'text',
    className = null,
    label = null,
    hasError = false,
    fullWidth = false,
    autoFocus = false,
    required = false,
    disabled = false,
    standard = true,
    readOnly = false,
    errorMessage = '',
    minLength,
    maxLength,
    min,
    max,
    step = '1.0',
    minRows = 10,
    maxRows = 100,
    icon = '',
    selectOptions = {},
    aria = '',
    style,
    adjustWidth = false,
    overrideIconStyle,
    marginBottom = true
}) => {
    const textTypes = ['text', 'number', 'password', 'date'];

    const textareaStyles = {
        minHeight: `${22 * (minRows || 1)}px`,
        maxHeight: `${22 * (maxRows || 3)}px`
    };

    return (
        <div
            className={`kds-standard-input-container ${fullWidth ? 'kds-standard-input-full-width' : ''}`}
            style={{ marginBottom: `${marginBottom ? '10px' : '0'}` }}
        >
            {label !== null && (
                <div className={`kds-standard-input-label ${disabled ? 'kds-standard-input-label-disabled' : ''}`}>
                    {label}
                    {required && <span className={'c-input--required'}> *</span>}
                </div>
            )}

            {textTypes.some((_type) => _type === type) && (
                <div className={`${adjustWidth ? className : ''}`}>
                    <input
                        className={`kds-standard-input
                            ${hasError ? 'kds-standard-input-error' : ''}
                            ${fullWidth ? 'kds-standard-input-full-width' : ''}
                            ${disabled ? 'kds-standard-input-disabled' : ''}
                            ${className ? className : ''}`}
                        id={id}
                        aria-label={aria}
                        minLength={minLength}
                        maxLength={maxLength}
                        name={name}
                        placeholder={placeholder}
                        type={type}
                        value={value}
                        autoFocus={autoFocus}
                        disabled={disabled}
                        readOnly={readOnly}
                        min={min}
                        max={max}
                        step={step}
                        onBlur={(e) => onBlur(e)}
                        onChange={(e) => onChange(e)}
                        onKeyDown={(e) => onKeyDown(e)}
                        onKeyUp={(e) => onKeyUp(e)}
                        onClick={(e) => onClick(e)}
                        style={style}
                    />

                    {icon && (
                        <FontAwesomeIcon
                            icon={icon as IconProp}
                            className={`c-sidenav__item-icon c-icon--small pointer c-icon--input ${overrideIconStyle ? 'override-icon-style' : ''}`}
                            onClick={(e) => onIconClick(e)}
                        />
                    )}
                </div>
            )}

            {type === 'textarea' && (
                <textarea
                    className={`kds-standard-input kds-standard-input__textarea
                        ${hasError ? 'kds-standard-input-error' : ''}
                        ${fullWidth ? 'kds-standard-input-full-width' : ''}
                        ${disabled ? 'kds-standard-input-disabled' : ''}
                        ${className ? className : ''}`}
                    style={textareaStyles}
                    id={id}
                    name={name}
                    aria-label={aria}
                    maxLength={maxLength}
                    placeholder={placeholder}
                    autoFocus={autoFocus}
                    value={value}
                    disabled={disabled}
                    min-rows={minRows}
                    max-rows={maxRows}
                    onBlur={(e) => onBlur(e)}
                    onChange={(e) => onChange(e)}
                    onKeyDown={(e) => onKeyDown(e)}
                    onKeyUp={(e) => onKeyUp(e)}
                    onClick={(e) => onClick(e)}
                />
            )}

            {type === 'select' && (
                <select
                    className={`
                        ${standard ? 'kds-standard-input' : ''}
                        kds-standard-input-select
                        ${hasError ? 'kds-standard-input-error' : ''}
                        ${disabled ? 'kds-standard-input-disabled' : ''}
                        ${fullWidth ? 'kds-standard-input-full-width' : ''}
                        ${className ? className : ''}`}
                    id={id}
                    placeholder={placeholder}
                    value={value}
                    disabled={disabled}
                    onBlur={(e) => onBlur(e)}
                    onChange={(e) => onChange(e)}
                >
                    {selectOptions.listItems.map((item: any) => {
                        if (!item) {
                            return <option value="" key=""></option>;
                        }

                        const value = item[selectOptions.value];
                        const key = item[selectOptions.key];
                        const display = item[selectOptions.display];

                        return (
                            <option value={value} key={key}>
                                {display}
                            </option>
                        );
                    })}
                </select>
            )}

            {hasError && <div className="kds-standard-input-error-message"> {errorMessage} </div>}
        </div>
    );
};

export default StandardInput;
